const state = {
  _templatePayingVisible: false
}

const getters = {
  templatePayingVisible: state => state._templatePayingVisible
}

const mutations = {
  setTemplatePayingVisible (state, flag) {
    state._templatePayingVisible = flag;
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/templates.js